import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=a1ef7472&scoped=true"
import script from "./UploadModal.vue?vue&type=script&lang=js"
export * from "./UploadModal.vue?vue&type=script&lang=js"
import style0 from "./UploadModal.vue?vue&type=style&index=0&id=a1ef7472&prod&lang=scss"
import style1 from "./UploadModal.vue?vue&type=style&index=1&id=a1ef7472&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ef7472",
  null
  
)

export default component.exports